import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MDBInput, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { faTrashAlt, faEdit, faPlus, faSearch, faCheckSquare } from '@fortawesome/free-solid-svg-icons'
import { NumericFormat } from 'react-number-format';

const ZonasDeEnvio = ({ baseUrl, Titulo, baseUrlUbica }) => {

	//almacena toda la data de categorias 
	const [data, setData] = useState([])
	//almacena el campo Nombre de categoria
	const [nombre, setNombre] = useState('')
	//almacena el campo Nombre de categoria
	const [color, setColor] = useState('')
	//almacena el campo Nombre de categoria
	const tiposEstados = ['contado', 'credito', 'cancelado']
	//almacena el campo Nombre de categoria
	const [tipo, setTipo] = useState('')
	//almacena el campo Nombre de categoria
	const [precio, setPrecio] = useState()
	//almacena el campo Nombre de categoria
	const [ubicaciones, setUbicaciones] = useState()
	//almacena el campo activo de categoria
	const [activo, setActivo] = useState(true)
	//almacena la categoria seleccionada
	const [categoriaSelect, setCategoriaSelect] = useState({})
	//selecciona la función como eliminar, crear, editar
	const [funcion, setFuncion] = useState('cargando')
	//Alerta del error para la validacion de formulario
	const [alerta, setAlerta] = useState(false)

	const [buscar, setBuscar] = useState(false)

	const [busqueda, setBusqueda] = useState('')

	//todos los checks activos o no
	const [checkActivos, setCheckActivos] = useState(false)


	//actualiza el registro de la categoria seleccionada
	const actualizarDato = (dato, name) => {
		setCategoriaSelect({ ...categoriaSelect, [name]: dato })
	}

	//hace la consulta y trae las categorias y los almacena en data 
	const peticionTraeDatos = async () => {
		await axios.get(baseUrl)
			.then(response => {
				let respuesta = response.data
				let newArr = []
				respuesta.map((item) => {
					newArr.push({
						...item,
						ubicaciones: JSON.parse(item.ubicaciones)
					})
				})
				setData(newArr)
				setFuncion('ver')

				console.log(newArr)
			})
	}

	//hace la consulta y trae las categorias y los almacena en data 
	const peticionTraeDatosUbica = async () => {
		await axios.get(baseUrlUbica)
			.then(response => {
				let respuesta = response.data
				let newArr = []
				respuesta.map((item) => {
					newArr.push({
						...item,
						check: false
					})
				})
				setUbicaciones(newArr)
			})
	}

	//realiza petición que borra de la base de datos por medio de la ID
	const peticionDelete = async () => {
		let f = new FormData();
		f.append("METHOD", "DELETE");
		await axios.post(baseUrl, f, { params: { id: categoriaSelect.id } })
			.then(response => {
				setData(data.filter(categoria => categoria.id !== categoriaSelect.id))
				setFuncion('ver')
			}).catch(error => {
				console.log(error)
			})
	}

	const Estaono = (array, id) => {
		let respuest = false
		array.map((item) => {
			if (item.id == id) {
				respuest = true
			}
		})
		return respuest
	}

	//Selecciona categoria para editarla o borrarla 
	const SeleccionarCategoria = (objeto, funcion) => e => {
		setFuncion(funcion)
		let ubicaSelect = objeto.ubicaciones
		console.log(ubicaSelect)

		let arr = []
		ubicaciones.map((item) => {
			if (Estaono(ubicaSelect, item.id)) {
				arr.push({
					...item,
					check: true
				})
			} else {
				arr.push({
					...item,
					check: false
				})
			}
		})

		console.log('res ', arr)
		setUbicaciones(arr)

		setCategoriaSelect({
			id: objeto.id,
			activo: objeto.activo === 'true' ? true : false,
			nombre: objeto.nombre,
			precio: objeto.precio
		})
		if (funcion === 'editar') {
			setFuncion('editar')
		}
	}

	//Consulta para editar campos
	const peticionPut = async () => {

		let UbicaListos = []
		ubicaciones.map((item) => {
			if (item.check) {
				UbicaListos.push(item)
			}
		})

		if (categoriaSelect.nombre !== '' && categoriaSelect.precio !== '') {
			let f = new FormData()
			//convierte boleano a cadena
			let cadena = categoriaSelect.activo ? 'true' : 'false'
			f.append("activo", cadena)
			f.append('nombre', categoriaSelect.nombre)
			f.append('precio', categoriaSelect.precio)
			f.append('ubicaciones', JSON.stringify(UbicaListos))
			f.append("METHOD", "PUT")
			await axios.post(baseUrl, f, { params: { id: categoriaSelect.id } })
				.then(response => {
					let dataNueva = data
					console.log(response.data)

					dataNueva.map(item => {
						if (item.id === categoriaSelect.id) {
							item.activo = cadena
							item.nombre = categoriaSelect.nombre
							item.precio = categoriaSelect.precio
							item.ubicaciones = UbicaListos
						}
					})
					setData(dataNueva)
					setBusqueda('')
					setFuncion('ver')
					setAlerta(false)
				}).catch(error => {
					console.log(error);
				})
		} else { setAlerta(true) }
	}

	//Consulta para subir o crear los datos 
	const peticionPost = async () => {

		let UbicaListos = []
		ubicaciones.map((item) => {
			if (item.check) {
				UbicaListos.push(item)
			}
		})

		if (nombre !== '' && precio !== '') {
			let f = new FormData()
			f.append('activo', activo.toString())
			f.append('nombre', nombre)
			f.append('precio', precio)
			f.append('ubicaciones', JSON.stringify(UbicaListos))
			f.append('METHOD', 'POST')
			await axios.post(baseUrl, f)

				.then(response => {
					let respuesta = response.data
					setData(data.concat({
						id: respuesta.id,
						activo: respuesta.activo,
						nombre: respuesta.nombre,
						precio: respuesta.precio,
						ubicaciones: JSON.parse(respuesta.ubicaciones)
					}));
					setNombre('')
					setPrecio()
					setUbicaciones(ReiniciaUbica())
					setBusqueda('')
					setActivo(true)
					setAlerta('')
					setFuncion('ver')
				}).catch(error => {
					console.log(error);
				})
		} else { setAlerta(true) }
	}

	//Trae todas las categorias de la api
	useEffect(() => {
		peticionTraeDatos()
		peticionTraeDatosUbica()
	}, [])

	const ReiniciaUbica = () => {
		let array = []
		ubicaciones.map((item) => { array.push({ id: item.id, nombre: item.nombre, check: false }) })
		return array
	}

	//Selecciona varios elementos y agrega en array listo para enviar a eliminar
	const SeleccionarVarios = ids => e => {
		if (SiesActivo(ids)) {
			console.log(SiesActivo(ids))
			let newArr = []
			actualizarCheck(newArr, ids, false)
			setUbicaciones(newArr)

		} else {
			console.log(SiesActivo(ids))
			let newArr = []
			actualizarCheck(newArr, ids, true)
			setUbicaciones(newArr)
			//console.log('si esta y es no esta activa')
		}
	}

	//revisa si si está el registro y mira si el check esta activo o no
	const SiesActivo = dato => {
		let resp = true
		ubicaciones.map((item) => {
			if (dato === item.id && item.check === false) {
				resp = false
			}
		})
		return resp
	}

	//actualiza el check agregando true o false al array
	const actualizarCheck = (newData, ids, chec) => {
		ubicaciones.map((item) => {
			if (item.id === ids) {
				newData.push({
					id: item.id,
					nombre: item.nombre,
					padre: item.padre,
					check: chec ? true : false
				})
			} else { newData.push(item) }
		})
		return newData
	}

	const SeleccionarTodo = (e) => {

		let newArr = []
		if (checkActivos) {
			ubicaciones.map((item) => {
				newArr.push({
					id: item.id,
					nombre: item.nombre,
					padre: item.padre,
					check: false
				})
			})
			setCheckActivos(false)
		} else {
			ubicaciones.map((item) => {
				newArr.push({
					id: item.id,
					nombre: item.nombre,
					padre: item.padre,
					check: true
				})
			})
			setCheckActivos(true)
		}

		console.log(newArr)
		setUbicaciones(newArr)
	}

	return (
		<div>
			<div className="row">
				<div className="col-md-6">
					<br />
					<h2>{Titulo}:</h2>
				</div>
				<div className="col-md-6">
					<div className="filtroPedidos">
						<button
							onClick={e => setFuncion('crear')}
							className="btn boton_estandar btn-lg derecha">
							<FontAwesomeIcon icon={faPlus} />
						</button>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12">

					{funcion === 'editar' ?
						<div>
							<h4>Actualizar Zona de Envio</h4>
							<hr />
							<div className='custom-control custom-switch '>
								<input
									type='checkbox'
									name="activo"
									className='custom-control-input form-control-lg mb-4'
									id='customSwitches'
									checked={categoriaSelect.activo}
									onChange={e => actualizarDato(e.target.checked, e.target.name)}
									readOnly
								/>
								<label className='custom-control-label' htmlFor='customSwitches'>
									Activar/Desactivar
								</label>
							</div>
							<MDBInput
								label="Nombre Zona de Envio"
								onChange={e => actualizarDato(e.target.value, e.target.name)}
								name="nombre"
								value={categoriaSelect && categoriaSelect.nombre}
								outline />

							<MDBInput
								label="Precio"
								value={categoriaSelect && categoriaSelect.precio}
								onChange={e => actualizarDato(e.target.value, e.target.name)}
								name="precio"
								type='number'
								outline />

							<div className="row">
								<div className="col-md-6">
									<h5 style={{ paddingTop: '10px' }}>Ubicaciones: </h5>
								</div>
								<div className="col-md-6">
									<button
										onClick={SeleccionarTodo}
										className="btn boton_estandar_blanco btn-lg derecha">
										<FontAwesomeIcon icon={faCheckSquare} />
									</button>
									<button
										onClick={e => setBuscar(!buscar)}
										className="btn boton_estandar_blanco btn-lg derecha">
										<FontAwesomeIcon icon={faSearch} />
									</button>
									{buscar ?
										<div className="buscarZonas">
											<MDBInput
												className="btnBuscar"
												name="busqueda"
												value={busqueda}
												onChange={e => setBusqueda(e.target.value)}
												placeHolder="Buscar"
												outline
											/>
										</div>
										: null}
								</div>
							</div>
							<div className="row">
								{ubicaciones.filter((item) => {
									if (busqueda == "") {
										return item.nombre
									} else if (item.nombre.toLowerCase().includes(busqueda.toLowerCase())) {
										return item.nombre
									}

								}).map((item, i) => {
									return (
										<div className="col-md-3" key={i}>
											<div className="custom-control custom-checkbox custom-control-inline">
												<input
													type="checkbox"
													checked={item.check}
													onClick={SeleccionarVarios(item.id)}
													id={item.id} className="custom-control-input"
												/>

												<label className="custom-control-label" htmlFor={item.id}>{item.nombre} <span className="coment">- {item.padre}</span></label>
											</div>
										</div>
									)
								})}
							</div>
							<br></br>

							{alerta ? <p className="error">¡Llena todos los campos!</p> : <span></span>}


							<br />
							<div className="col text-center">
								<button
									onClick={peticionPut}
									className="btn boton_estandar"
								>Actualizar Zona de Envio
								</button>
								<button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar"
								>Cancelar
								</button>
							</div>
						</div>
						: null}

					{funcion === 'crear' ?

						<div>
							<h4>Subir Zona de Envio</h4>
							<hr />
							<div className='custom-control custom-switch '>
								<input
									type='checkbox'
									name="activo"
									className='custom-control-input form-control-lg mb-4'
									id='customSwitches'
									checked={activo}
									onChange={e => setActivo(!activo)}
									readOnly
								/>
								<label className='custom-control-label' htmlFor='customSwitches'>
									Activar/Desactivar
								</label>
							</div>
							<MDBInput
								label="Nombre Zona de Envio"
								value={nombre}
								onChange={e => setNombre(e.target.value)}
								name="nombre"
								required
								outline />

							<MDBInput
								label="Precio"
								value={precio}
								onChange={e => setPrecio(e.target.value)}
								name="precio"
								required
								type='number'
								outline />

							<div className="row">
								<div className="col-md-6">
									<h5 style={{ paddingTop: '10px' }}>Ubicaciones: </h5>
								</div>
								<div className="col-md-6">
									<button
										onClick={SeleccionarTodo}
										className="btn boton_estandar_blanco btn-lg derecha">
										<FontAwesomeIcon icon={faCheckSquare} />
									</button>
									<button
										onClick={e => setBuscar(!buscar)}
										className="btn boton_estandar_blanco btn-lg derecha">
										<FontAwesomeIcon icon={faSearch} />
									</button>
									{buscar ?
										<div className="buscarZonas">
											<MDBInput
												className="btnBuscar"
												name="busqueda"
												value={busqueda}
												onChange={e => setBusqueda(e.target.value)}
												placeHolder="Buscar"
												outline
											/>
										</div>
										: null}
								</div>
							</div>
							<div className="row">
								{ubicaciones.filter((item) => {
									if (busqueda == "") {
										return item.nombre
									} else if (item.nombre.toLowerCase().includes(busqueda.toLowerCase())) {
										return item.nombre
									}

								}).map((item) => {
									return (
										<div className="col-md-3">
											<div className="custom-control custom-checkbox custom-control-inline">
												<input
													type="checkbox"
													checked={item.check}
													onClick={SeleccionarVarios(item.id)}
													id={item.id} className="custom-control-input"
												/>

												<label className="custom-control-label" htmlFor={item.id}>{item.nombre} <span className="coment">- {item.padre}</span></label>
											</div>
										</div>
									)
								})}
							</div>
							<br></br>

							{alerta ? <p className="error">¡Llena todos los campos!</p> : <span></span>}

							<div className="col text-center">

								<button
									onClick={peticionPost}
									className="btn boton_estandar"
								>Subir Zona de Envio
								</button>
								<button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar"
								>Cancelar
								</button>

							</div>
						</div>
						: null}

					{funcion === 'eliminar' ?

						<div>
							<h4>¿Desea Realmente Eliminar?</h4>
							<hr />
							<div className="col text-center">

								<p>Zona de envio: {categoriaSelect.nombre}</p>
								<button
									onClick={peticionDelete}
									className="btn boton_estandar"
								>Eliminar
								</button>
								<button
									onClick={e => setFuncion('ver')}
									className="btn boton_estandar"
								>Cancelar
								</button>

							</div>
						</div>
						: null}

					{funcion === 'cargando' ?
						<div className="loader">Loading...</div>
						: null}

					{funcion === 'ver' ?

						<div>
							<MDBTable hover responsive>
								<MDBTableHead>
									<tr>
										<th>Id</th>
										<th>Activo</th>
										<th>Nombre</th>
										<th>Ubicaciones</th>
										<th>Precio</th>
										<th></th>
									</tr>
								</MDBTableHead>
								<MDBTableBody>

									{data.map((item, index) => {
										return (
											<tr key={index}>
												<td>{item.id}</td>
												<td>{item.activo === 'true' ? 'Si' : 'No'}</td>
												<td>{item.nombre}</td>
												<td>
													{item.ubicaciones.map((item, i) => {
														return (<span key={i}>{item.nombre}, </span>)
													})}
												</td>
												<td><NumericFormat displayType="text" value={item.precio.toString()} prefix={'$'} thousandSeparator={true} /></td>
												<td className="tabla_funciones">
													<div className="col text-center">
														<button
															onClick={SeleccionarCategoria(item, 'editar')}
															className="btn boton_estandar_blanco"
														><FontAwesomeIcon icon={faEdit} size="lg" />
														</button>

														<button
															onClick={SeleccionarCategoria(item, 'eliminar')}
															className="btn boton_estandar_blanco"
														><FontAwesomeIcon icon={faTrashAlt} size="lg" />
														</button>
													</div>

												</td>
											</tr>
										)
									})}

								</MDBTableBody>
							</MDBTable>
						</div>

						: null}
				</div>
			</div>
		</div>
	)
}

export default ZonasDeEnvio